import { render, staticRenderFns } from "./TheLandscapeNotice.vue?vue&type=template&id=02b9b9cc&"
import script from "./TheLandscapeNotice.vue?vue&type=script&lang=js&"
export * from "./TheLandscapeNotice.vue?vue&type=script&lang=js&"
import style0 from "./TheLandscapeNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports